module.exports = __webpack_public_path__ + "img/mk-question.6ed9169.png";